import Header from "./components/Header/Header";
import PhotographersGrid from "./components/PhotographersGrid/PhotographersGrid";

export default function Home() {
  return (
    <>
      <Header />
      <PhotographersGrid />
    </>
  );
}
